import { Permission } from '../model/enumeration/Permission.enum';
import authStore from './AuthStore';

class PermissionStore {
  public hasPermission = (permission: Permission): boolean =>
    authStore.authenticatedUser?.permissions?.some(p => p === permission);

  public isRootAdmin = (): boolean =>
    authStore.authenticatedUser?.username === 'admin';
}

const permissionStore = new PermissionStore();
export default permissionStore;
